import React, { Component } from 'react'
import { extendParentClass, extendBaseClass } from '../../../../utils/classes'

export class Indicator extends Component {
  baseClass = extendParentClass.bind(this)('indicator')

  extend = extendBaseClass.bind(this)

  render() {
    const { name, value } = this.props
    return (
      <div className={this.baseClass}>
        <h2 className={this.extend('value')}>{value}</h2>
        <span className={this.extend('name')}>{name}</span>
      </div>
    )
  }
}

export default Indicator
